import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import App from 'common/backbone-app';
import * as actions from 'reduxStore/common/employees/actions';
import { getConfigurableEmployeePermissions } from 'reduxStore/common/employees/selectors';
import {
  canEditEmployee,
  getProfileEditDisableReason,
} from 'components/employees/employeeEditPolicy';
import { getActorContext, getTargetEmployee } from 'components/employees/employeePolicyContext';
import { EmployeeInformationTab as Component } from './index';

const mapStateToProps = (state) => {
  const {
    employees: {
      employee: {
        id,
        name,
        takesAppointments,
        phone,
        emailAddress,
        role,
        image,
        employmentStatus,
        supplierBound,
        active,
      },
      submitting,
      serverErrorName,
      serverErrorData,
      serverErrorAction,
    },
  } = state;

  const pointOfSalePermissionsVisible = App.config.get('venue').pointOfSaleEnabled;
  const selectedPermissions = getConfigurableEmployeePermissions(state, {
    pointOfSalePermissionsVisible,
  });
  const actor = getActorContext();
  const target = getTargetEmployee({
    id,
    role,
    permissions: selectedPermissions,
    supplierBound,
    active,
  });
  const profileFieldsDisabled = canEditEmployee(actor, target) === 'none';

  return {
    employmentStatus,
    id,
    name,
    takesAppointments,
    phone,
    emailAddress,
    emailDisabled: App.config.getAccountEmployeeId() === id,
    role,
    imageUris: image ? image.uris : null,
    submitting,
    serverErrorName,
    serverErrorData,
    serverErrorAction,
    profileFieldsDisabled,
    profileDisableReason: getProfileEditDisableReason(actor, target),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(actions, dispatch),
});

// @ts-expect-error ts-migrate(2345) FIXME: Type '{ employmentStatus: undefined; id: null; nam... Remove this comment to see the full error message
export const EmployeeInformationTab = connect(mapStateToProps, mapDispatchToProps)(Component);
